import React from 'react';

const R = 5;

interface IDefaultBarShapeProps {
  x?: number;
  y?: number;
  width?: number;
  height?: number;
  payload?: { increase?: number };
  fill?: string;
}

/** Рисует столбец default со скруглением верхних углов, если нет increase (столбец один в стеке). */
export const DefaultBarShape: React.FC<IDefaultBarShapeProps> = props => {
  const { x = 0, y = 0, width = 0, height = 0, payload, fill } = props;
  const hasIncrease = payload?.increase != null && payload.increase > 0;

  if (hasIncrease) {
    return <rect x={x} y={y} width={width} height={height} fill={fill} />;
  }

  const path =
    `M ${x + R},${y}` +
    ` L ${x + width - R},${y}` +
    ` Q ${x + width},${y} ${x + width},${y + R}` +
    ` L ${x + width},${y + height}` +
    ` L ${x},${y + height}` +
    ` L ${x},${y + R}` +
    ` Q ${x},${y} ${x + R},${y}` +
    ' Z';

  return <path d={path} fill={fill} />;
};
